import request from 'api/request';

export default function resendConfirmationRoute(email) {
  return request({
    url: '/emails/resend',
    method: 'PUT',
    data: { email },
  });
}
